import React from 'react'
import Hamburger from 'react-hamburgers'
import { useDispatch, useSelector } from 'react-redux'
import AppMobileMenu from '../AppMobileMenu'
import { LblAmbiente } from './styles'

export default function AppLogo() {
  const dispatch = useDispatch()
  const enableMobileMenuSmall = useSelector((state) => state.enableMobileMenuSmall)
  const enableClosedSidebar = useSelector((state) => state.enableClosedSidebar)

  function toggleEnableClosedSidebar() {
    dispatch({ type: 'enableClosedSidebar', value: !enableClosedSidebar })
  }

  return (
    <>
      <div className="app-header__logo">
        {process.env.REACT_APP_ENVIRONMENT === 'PROD' ? <div className="logo-src"></div> : <LblAmbiente> {enableClosedSidebar && enableMobileMenuSmall === false ? 'H' : 'Homologação'} </LblAmbiente>}
        <div className="header__pane ml-auto">
          <div onClick={toggleEnableClosedSidebar}>
            <Hamburger
              active={!enableClosedSidebar}
              type="elastic"
              onClick={() => {
                toggleEnableClosedSidebar()
              }}
            />
          </div>
        </div>
      </div>
      <AppMobileMenu />
    </>
  )
}
